import React, { useContext } from "react";
import SessionHandler from "../../https/SessionHandler";
import { UserContext } from "../../contexts/AppContext";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";
import { Container, Stack, Typography } from "@mui/material";
import { createStyles, makeStyles } from "@material-ui/core";
import { useQuery } from "../../utils/App";
import { CardCategory } from "./components/CardCategory";
import CottageTwoToneIcon from "@mui/icons-material/CottageTwoTone";
import CabinTwoToneIcon from "@mui/icons-material/CabinTwoTone";
import HolidayVillageTwoToneIcon from "@mui/icons-material/HolidayVillageTwoTone";
import CarRentalIcon from '@mui/icons-material/CarRental';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import fond_result_search from "../../images/fond_result_search.png";
import { ISnackbar } from "../../utils/enum/snackBarType";
import { AfriqSnackbar } from "../components/OverridingMaterial/AfriqSnackbar";
import { ERoles } from "../../utils/enum";

const useStyles = makeStyles(() =>
    createStyles({
        root: {
            paddingBottom: 100,
        },
        typo1: {
            fontSize: 20,
            fontWeight: 400,
            lineHeight: 28,
            fontFamily: "Josefin Sans",
            marginBottom: 32,
        },
        img: {
            width: "100%",
            objectFit: "cover",
        },
    })
);

export const Category = () => {
    const sessionHandler = React.useMemo(() => new SessionHandler(), []);
    const isConnected = sessionHandler.isConnected;
    const userContext = useContext(UserContext);
    const { user, setUser } = userContext;
    const history = useHistory();
    const classes = useStyles();
    const { t } = useTranslation<'common'>();
    const [, setLoading] = React.useState(false);
    let query = useQuery();
    const [snackValues, setSnackValues] = React.useState<ISnackbar>({
        type: "success",
        open: false,
        message: "",
    });
    const handleCloseSnackbar = () => {
        setSnackValues({ ...snackValues, open: false });
    };

    React.useEffect(() => {
        if (!user.email) {
            isConnected()
                .then((response: any) => {
                    if (response.success) {
                        setUser(response.data);
                    }
                })
                .catch((err: any) => {
                    history.push("/");
                });
        } else {
            setLoading(true);
        }
    }, [user, history, isConnected, setUser]);
    const handleClick = () => {
        query.set("ajout", "Hôtel");
        history.push({ pathname: "/announce/add", search: query.toString() });
    };
    const handeleExist = () => {
        query.set("ajout", "exist");
        history.push("/announceHotel/add");
    };
    return (
        <div className={classes.root}>
            <img src={fond_result_search} alt="fond" className={classes.img} />
            <Container>
                <Stack direction="column" marginTop={3.75}>
                    <Stack direction="column" sx={{ textAlign: "center" }}>
                        <Typography variant="h6" className={classes.typo1}>
                            {t("label.inscrivez-et-recevez")}
                        </Typography>
                        <Typography
                            variant="h6"
                            fontSize={16}
                            fontWeight={400}
                            lineHeight="24px"
                            fontFamily="Josefin Sans"
                            marginBottom="30px"
                        >
                            {t("label.pour-commencer-choisissez")}
                        </Typography>
                    </Stack>
                    <Stack
                        direction="row"
                        flexWrap="wrap"
                        gap="50px"
                        justifyContent="center"
                    >
                        {(user.role.name === ERoles.HOTEL_ADMIN ||
                            user.role.name === ERoles.GUEST || user.role.name === ERoles.SUPER_ADMIN) && (
                            <CardCategory
                                icon={HolidayVillageTwoToneIcon}
                                title={t("label.profil-hotel")}
                                subtitle={t("label.hebergement-profil-hotel")}
                                btnTitle={t("label.creez-votre-hotel")}
                                handleExist={handleClick}
                            />
                        )}

                        <CardCategory
                            icon={CabinTwoToneIcon}
                            title={t("label.annonce-de-logement")}
                            subtitle={t(
                                "label.hebergement-meuble-avec-cuisine"
                            )}
                            btnTitle={t("label.creez-une-annonce-de-logement")}
                            handleExist={() => {
                                history.push("/announce/add");
                            }}
                        />
                        
                            <CardCategory
                                icon={
                                    CottageTwoToneIcon}
                                title={t("label.hotel-existant")}
                                subtitle={t("label.hebergement-annonce-hotel")}
                                btnTitle={t("label.creez-vos-annonces")}
                                handleExist={handeleExist}
                            />
                      
                            <CardCategory
                                icon={CarRentalIcon}
                                title={t("label.location-voiture")}
                                subtitle={t("label.desc-location-voiture")}
                                btnTitle={t("label.creez-annonce-voiture")}
                                handleExist={() => {
                                    history.push("/announceCar/add");
                                }}
                            />
                        
                        {(user.role.name === ERoles.COUNTRY_ADMIN || user.role.name === ERoles.SUPER_ADMIN || user.role.name === ERoles.ADMIN_SUPPORT) && (
                            <CardCategory
                                icon={HomeWorkIcon}
                                title={t("label.bien-immobilier")}
                                subtitle={t("label.desc-bien-immobilier")}
                                btnTitle={t("label.creez-annonce-immobilier")}
                                handleExist={() => {
                                    history.push("/announceImmo/add");
                                }}
                            />
                        )}
                      
                            <CardCategory
                                icon={HomeWorkIcon}
                                title={t("label.experience-announce")}
                                subtitle={t("label.desc-experience")}
                                btnTitle={t("label.creez-annonce-experience")}
                                handleExist={() => {
                                    history.push("/announceExp/add");
                                }}
                            />
                       
                    </Stack>
                </Stack>
            </Container>
            <AfriqSnackbar {...snackValues} handleClose={handleCloseSnackbar} />
        </div>
    );
};
